import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { BreadcrumbComponent } from '../components/breadcrumb/breadcrumb.component';
import { SimpleDialogComponent } from '../components/simple-dialog/simple-dialog.component';
import { DynamicPipe } from '../pipes/dynamic.pipe';
import { BarrierProfileService } from './master-vehicles/services/barrier-profile.service';
import { MasterVehicleService } from './master-vehicles/services/master-vehicle.service';
import { TypeVehicleService } from './master-vehicles/services/type-vehicle.service';
import { MatSortModule } from '@angular/material/sort';
import { MatMenuModule } from '@angular/material/menu';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SimpleDataDialogComponent } from '../components/simple-data-dialog/simple-data-dialog.component';
import { SimpleDataListComponent } from '../components/simple-data-list/simple-data-list.component';
import { FilterComponent } from '../components/filter/filter.component';

const MATERIALS: any[] = [
  MatDialogModule,
  MatIconModule,
  MatListModule,
  MatRadioModule,
  MatFormFieldModule,
  MatSlideToggleModule,
  MatCardModule,
  MatTabsModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatCheckboxModule,
  MatInputModule,
  MatButtonModule,
  MatBottomSheetModule,
  MatTooltipModule,
  MatSnackBarModule,
  MatPaginatorModule,
  MatTableModule,
  MatSortModule,
  MatMenuModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatAutocompleteModule,
  MatChipsModule,
  MatProgressBarModule,
];

const COMPONENTS: any[] = [BreadcrumbComponent, SimpleDialogComponent, SimpleDataDialogComponent, SimpleDataListComponent, FilterComponent];

@NgModule({
  declarations: [COMPONENTS, DynamicPipe, SimpleDialogComponent],
  imports: [MATERIALS, FormsModule, ReactiveFormsModule, RouterModule, CommonModule, FlexLayoutModule],
  providers: [BarrierProfileService, MasterVehicleService, TypeVehicleService],
  exports: [MATERIALS, FormsModule, ReactiveFormsModule, CommonModule, FlexLayoutModule, COMPONENTS, DynamicPipe, SimpleDialogComponent],
})
export class SharedModule {}
